import React from "react";
import { Box, Container, Stack } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { retrieveNewBooks } from "./selector";
import { Product } from "../../../lib/types/product";
import { serverApi } from "../../../lib/config";
import { CartItem } from "../../../lib/types/search";
import { useHistory } from "react-router-dom";

interface ChosenProductsProps {
  onAdd: (item: CartItem) => void;
}

const newBooksRetriever = createSelector(retrieveNewBooks, (newBooks) => ({
  newBooks,
}));

export default function NewBooks(props: ChosenProductsProps) {
  const { onAdd } = props;
  const { newBooks } = useSelector(newBooksRetriever);
  const history = useHistory();

  const chooseBookHandler = (id: string) => {
    history.push(`/products/${id}`);
  };

  return (
    <div className={"new-books-frame"}>
      <Container>
        <Stack className={"main"}>
          <Stack className={"section-heading"}>
            <span className={"section-kicker"}>Fresh shelf</span>
            <Box className={"category-title"}>New Books</Box>
            <p>Recently added titles ready for your next reading list.</p>
          </Stack>

          <Stack className={"cards-frame books-grid new-grid"}>
            {newBooks.length !== 0 ? (
              newBooks.map((product: Product, index: number) => {
                const imagePath = `${serverApi}/${product.productImages[0]}`;
                return (
                  <article
                    className={`book-card new-book-card ${index === 0 ? "new-feature" : ""}`}
                    key={product._id}
                  >
                    <div
                      className={"book-cover"}
                      data-title={product.productName}
                      onClick={() => chooseBookHandler(product._id)}
                    >
                      <img
                        src={imagePath}
                        alt=""
                        onError={(event) => {
                          event.currentTarget.style.display = "none";
                        }}
                      />
                      <span className={"book-rank"}>{product.productSize}</span>
                    </div>
                    <div className={"book-detail"}>
                      <span className={"book-label"}>New arrival</span>
                      <h3 onClick={() => chooseBookHandler(product._id)}>
                        {product.productName}
                      </h3>
                      <p>{product.productAuthor}</p>
                      <div className={"book-footer"}>
                        <strong>${product.productPrice}</strong>
                        <span>
                          <FavoriteIcon fontSize="inherit" /> {product.productLikes}
                        </span>
                        <span>
                          <VisibilityIcon fontSize="inherit" /> {product.productViews}
                        </span>
                      </div>
                      <button
                        className={"add-cart-btn"}
                        type="button"
                        onClick={(e) => {
                          onAdd({
                            _id: product._id,
                            quantity: 1,
                            name: product.productName,
                            price: product.productPrice,
                            image: product.productImages[0],
                          });
                          e.stopPropagation();
                        }}
                      >
                        <ShoppingCartIcon fontSize="inherit" /> Add to cart
                      </button>
                    </div>
                  </article>
                );
              })
            ) : (
              <Box className="no-data">New books are not available yet.</Box>
            )}
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}
